import { convertDistance, DistanceUnit } from '@backend/lib-l10n-logic';
import queryString from 'query-string';

import { getJobsBusinessUnitUrlPath } from '~/config';
import { stringifyAddress } from '~/utils/address';
import { getDefaultParams } from '~/utils/search/getDefaultSearchParams';
import { getDistanceConfig } from '~/utils/search/getDistanceConfig';
import type { SearchParams } from '~/utils/search/types';
import { createSlug } from '~/utils/slug';

export const generateSearchUrl = (params: SearchParams, businessUnit: string, country: string): string => {
  const paths = [getJobsBusinessUnitUrlPath(businessUnit)];

  const query: Record<string, string> = {};
  const defaultParams = getDefaultParams(country);

  if (params.address) {
    paths.push(stringifyAddress({ ...params.address, name: createSlug(params.address.name) }));
    if (params.distance && params.distance !== defaultParams.distance) {
      const distanceConfig = getDistanceConfig(country);

      query.distance = String(
        convertDistance({ value: params.distance, unit: DistanceUnit.KM }, distanceConfig.unit, { precision: 0 }).value,
      );
    }
  }

  if (params.job) {
    paths.push(createSlug(params.job));
  }
  if (params.page && params.page > defaultParams.page) {
    query.page = String(params.page);
  }
  if (params.sort && params.sort !== defaultParams.sort) {
    query.sort = params.sort;
  }
  if (params.type && params.type !== 'all') {
    query.type = params.type;
  }
  if (params.experience && params.experience !== 'all') {
    query.experience = params.experience;
  }

  const path = paths.join('/');

  const parsedQuery = queryString.stringify(query);

  if (parsedQuery) {
    return `${path}?${parsedQuery}`;
  }
  return path;
};
